export const GAME_EVENT_IMAGE_WIDTH = 1024;
export const GAME_EVENT_IMAGE_HEIGHT = 512;
